import { useState } from 'react';
import styles from './Interactive.module.css';

interface TrueFalseProps {
  onSubmit: (answer: string) => void;
  disabled: boolean;
  showResult: boolean;
  correctAnswer: string;
}

export function TrueFalse({ onSubmit, disabled, showResult, correctAnswer }: TrueFalseProps) {
  const [selected, setSelected] = useState<string | null>(null);

  const handleSelect = (value: string) => {
    if (disabled) return;
    setSelected(value);
    onSubmit(value);
  };

  const getButtonClass = (value: string) => {
    let className = styles.trueFalseButton;

    if (showResult) {
      if (value === correctAnswer) {
        className += ` ${styles.correct}`;
      } else if (value === selected && value !== correctAnswer) {
        className += ` ${styles.incorrect}`;
      }
    } else if (value === selected) {
      className += ` ${styles.selected}`;
    }

    return className;
  };

  return (
    <div className={styles.trueFalseContainer}>
      <button
        className={getButtonClass('true')}
        onClick={() => handleSelect('true')}
        disabled={disabled}
      >
        <span className={styles.trueFalseIcon}>✓</span>
        True
      </button>
      <button
        className={getButtonClass('false')}
        onClick={() => handleSelect('false')}
        disabled={disabled}
      >
        <span className={styles.trueFalseIcon}>✗</span>
        False
      </button>
    </div>
  );
}
